// extracted by mini-css-extract-plugin
export var deleteModal = "_gy-0";